module.exports = __webpack_public_path__ + "static/media/the_path_to_the_river_small.b6a0ae03.jpg";